import React, { useContext } from 'react';
import _get from 'lodash/get';
import Rating from 'react-rating';
import { useDispatch } from 'react-redux';
import { Trash2 } from 'lucide-react';
import ConfirmationModal from '../../../components/ConfirmationModal';
import TestStatus from './TestStatus';
import { getStar } from '../../../utils/helpers/getStar';
import Button from '../../../components/Button';
import GlobalContext from '../../../utils/GlobalContext';
import {
  bmcBlocksObject,
  bmcBlockShortNames,
} from '../../../utils/factories/bmcBlocks';
import { testTypeOptions } from '../../../utils/factories/testTypes';

const TestRow = ({
  test: testObject,
  onClick,
  isPreview = false,
  backgroundRow,
  borderCardColor,
  testTypeColor,
  textColor,
  rateColor,
  titles: testText,
  isColourfulfunTemplate = false,
}) => {
  const { locales } = useContext(GlobalContext);
  const test = _get(testObject, 'test', '');
  const text = _get(testObject, 'assumption.text', '');
  const blocks = _get(testObject, 'assumption.blocks', []);
  const status = _get(testObject, 'analyse.status');

  const previewTestText = _get(testText, `[${test}.text]`, '');
  const previewTestRating = _get(testText, `[${test}.rating]`, '');

  const {
    testing: { deleteTest },
  } = useDispatch();

  const handleDelete = async (e) => {
    e.stopPropagation();
    deleteTest(testObject.id);
  };

  const getAssumptionBlock = () => {
    return (
      <div className="assumption test-card-section">
        <div
          className="header-assumption custom-font-body"
          style={{ color: textColor }}
        >
          {locales.testing.testCard.assumption}
        </div>
        <div className="text custom-font-body" style={{ color: textColor }}>
          {text}
        </div>
      </div>
    );
  };

  return (
    <div
      className="test-card test-card--row card flex flex-row gap-2"
      style={{ borderColor: borderCardColor, backgroundColor: backgroundRow }}
    >
      <div className="main flex-1">
        <div className="test-type test-card-section">
          <div
            className="header-type custom-font-body"
            style={{ color: textColor }}
          >
            {locales.testing.testCard.testType}
          </div>

          <Button
            variant="ghost"
            className="flex flex-col justify-start items-start"
            onClick={onClick}
          >
            <div
              className="type custom-font-title"
              style={{ color: testTypeColor }}
            >
              {isPreview ? previewTestText : testTypeOptions[test]}
            </div>
            {!isPreview && test !== null && test !== '' && (
              <div className="rating">
                <Rating
                  className="rate"
                  readonly
                  initialRating={previewTestRating}
                  fullSymbol={getStar('full', rateColor)}
                  emptySymbol={getStar('empty', rateColor)}
                />
              </div>
            )}
          </Button>
        </div>
        {!isColourfulfunTemplate && getAssumptionBlock()}
        <div className="bmc-status-wrapper">
          <div className="bmc-blocks-wrapper test-card-section">
            <div
              className="header-blocks custom-font-body"
              style={{ color: textColor }}
            >
              {locales.testing.testCard.bmcBlocksTested}
            </div>
            <div className="bmc-blocks">
              {Object.entries(bmcBlocksObject).map(([key]) => {
                return (
                  blocks.includes(key) && (
                    <div
                      key={key}
                      className={`bmc-blocks__block bmc-blocks__block-${key} custom-font-title`}
                    >
                      {bmcBlockShortNames[key]}
                    </div>
                  )
                );
              })}
            </div>
          </div>
          <div className="status test-card-section">
            <div
              className="header-status custom-font-body"
              style={{ color: textColor }}
            >
              {locales.testing.testCard.status}
            </div>
            <TestStatus status={status} />
          </div>
        </div>
      </div>
      {!isPreview && (
        <ConfirmationModal
          buttonAriaLabel={locales.testing.testCard.delete}
          body={locales.testing.testCard.deleteConfirmation}
          confirmText={locales.testing.testCard.delete}
          onConfirm={handleDelete}
          className="text-muted-darker"
        >
          <Trash2 className="w-6 min-w-6 h-auto" />
        </ConfirmationModal>
      )}
      {isColourfulfunTemplate && getAssumptionBlock()}
    </div>
  );
};

export default TestRow;
